import {Component, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {AbstractControl, FormControl, FormGroup} from '@angular/forms';
import { Validators } from '../../../common/forms';
import {ToastService} from '../../../main/services';
import {TenderAnalyticsSettingsService} from '../../services';
import {User} from '../../../auth/models';
import {TenderAnalyticsSettings} from '../../models';
import {PaymentTypesCollection} from '../../../common/models/payment-type';
import {tenderAnalyticsSettingsForm} from '../../forms/tender-analytics-settings.form';
import {PAYMENT_TYPES} from '../../../common/models/payment-type/payment-types';
import {FormValidationErrorsHelper} from '../../../common/helpers/forms/form-validation-errors-helper';


@Component({
    selector: 'jft-tender-analytics-settings',
    templateUrl: './tender-analytics-settings.component.html',
    styleUrls: ['tender-analytics-settings.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class TenderAnalyticsSettingsComponent implements OnInit {
    public paymentTypesCollection: PaymentTypesCollection;
    public loading: boolean = false;
    public tenderId: string;

    constructor(
        protected route: ActivatedRoute,
        private service: TenderAnalyticsSettingsService,
        private toast: ToastService,
        public user: User
    ) {

    }

    public ngOnInit() {
        let data = this.route.snapshot.data;
        this.paymentTypesCollection = data['paymentTypesCollection'];
        this.tenderId = this.route.snapshot.parent.params.id;
    }
}
